import React from 'react'

const PickupLoc = () => {
  return (
    <div>PickupLoc</div>
  )
}

export default PickupLoc